{
  "aboutCluster": "Om nettverket",
  "businessCode": "Næringskode (juridisk eigar)",
  "businessCodeInfoText": "Denne fyllast inn automatisk når organisasjonsnummer på juridisk eigar er fylt ut.",
  "cluster": "Klyngen",
  "clusterManagement": "Klyngeleiing",
  "clusterName": "Namn",
  "clusterStatus": "Status",
  "dateOfFoundation": "Stiftingsdato",
  "legalOwner": "Juridisk eigar",
  "legalOwnerOrgnumber": "Organisasjonsnummer til juridisk eigar",
  "mainContact": "Hovudkontakt",
  "membershipFee": "Medlemskontingent",
  "statistics.inKindCost": "Totalkost på eigeninnsats for medlemmar over tid",
  "statistics.live": "Live statistikk",
  "yourProfile": "Profilen din"
}
